import styled from 'styled-components';

export const GeneralTabStyle = styled.div`
  position: relative;
  font-size: 15px;
  line-height: 1.55;
  color: var(--ink);

  .title {
    display: block;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 600;
    margin: 0 0 6px;
    color: var(--ink);
  }

  .email {
    display: block;
    color: var(--mute);
    font-size: 15px;
  }

  .text-box {
    flex: 1;
    min-width: 0;

    p {
      margin: 0;
      color: var(--mute);
      font-size: 14px;
    }
  }

  .holder {
    margin: 0 0 16px;
    padding: 18px 20px;
    background: var(--white);
    border: 1px solid var(--line);
    border-radius: var(--r-lg);
    box-shadow: var(--shadow-soft);

    &.flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;
    }
  }
`;
